const catalogResponse = (raw) => {
  const sortedCatalog = raw.features[0].properties.dates.sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );
  return sortedCatalog;
};

export default catalogResponse;
